import React from 'react';
import UserAvatar from './UserAvatar';
import CustomTooltip from '../CustomTooltip';
import './UserAvatarGroup.css';

const UserAvatarGroup = ({
	referenceId = 'portfolio',
	users = [],
	maxVisible = 4,
	size = 'large',
	showTooltip = true,
	onUserClick,
	onMoreClick,
	className = '',
}) => {
	if (!users || users.length === 0) {
		return (
			<div className={`user-avatar-group ${className}`}>
				<div className="no-users-message text-muted">
					<i className="bi bi-person-plus me-1"></i>
					No users assigned
				</div>
			</div>
		);
	}

	const visibleUsers = users.slice(0, maxVisible);
	const remainingCount = users.length - maxVisible;

	return (
		<div className={`user-avatar-group ${className}`}>
			{visibleUsers.map((user, index) => (
				<UserAvatar
					key={`avatar-${user.id || user.email || index}-${referenceId}`}
					user={user}
					size={size}
					showTooltip={showTooltip}
					onClick={onUserClick ? () => onUserClick(user) : undefined}
					className="portfolio-avatar"
					style={{
						zIndex: visibleUsers.length - index,
					}}
				/>
			))}

			{remainingCount > 0 && (
				<CustomTooltip
					content={`${remainingCount} more user${
						remainingCount > 1 ? 's' : ''
					}`}
					placement="top"
					delay={100}
				>
					<div
						className={`user-avatar-count user-avatar-count-${size}`}
						onClick={onMoreClick}
						style={{
							cursor: onMoreClick ? 'pointer' : 'help',
							transition: 'opacity 0.2s ease',
						}}
						onMouseEnter={(e) => {
							e.target.style.opacity = '0.8';
						}}
						onMouseLeave={(e) => {
							e.target.style.opacity = '1';
						}}
					>
						+{remainingCount}
					</div>
				</CustomTooltip>
			)}
		</div>
	);
};

export default UserAvatarGroup;
